import message from './message.json';

const ListMessage: any = {
  ...message,
};

export { ListMessage };
